import { STEAL_DEAL_ITEM_IMAGE_SIZE, STEAL_DEAL_V2_IMAGE_SIZE } from "../constants";

export const getStealDealItemImageSize = (isSnaccStorefrontV2 = false) => {
    const { WIDTH: width, HEIGHT: height } = isSnaccStorefrontV2
        ? STEAL_DEAL_V2_IMAGE_SIZE
        : STEAL_DEAL_ITEM_IMAGE_SIZE;

    return { width, height };
};
